import { rem } from 'polished'
import type { PropsWithChildren, ReactElement } from 'react'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { _searchTileContainerQueryUp } from './_MetaSearchTileBase'
import LuxuryEscapesSmallLogo from 'components/App/Header/Logo/logos/LuxuryEscapesSmallLogo'
import SolidGoogleColourIcon from 'LuxKit/Icons/solid/SolidGoogleColourIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import Group from 'components/utils/Group'

const LE_ICON = <LuxuryEscapesSmallLogo height={20} width={20} />
const GOOGLE_ICON = <SolidGoogleColourIcon size={20} />

const Container = styled.div`
  grid-area: pricing;
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
  align-items: stretch;
  min-width: ${rem(80)};
  max-width: ${rem(200)};

  ${_searchTileContainerQueryUp.tablet} {
    gap: ${rem(8)};
  }

  ${_searchTileContainerQueryUp.desktopSmall} {
    gap: ${rem(12)};
  }

  ${_searchTileContainerQueryUp.desktop} {
    gap: ${rem(8)};
  }
`

const Details = styled.div`
  flex-grow: 1;
`

const Action = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  &:empty {
    display: none;
  }
`

interface Props extends PropsWithChildren {
  action: ReactElement | false
  variant?: 'default' | 'meta'
  hideLogoAndTitle?: boolean
}

function _MetaSearchTilePricing({ children, action, variant = 'default', hideLogoAndTitle = false }: Props) {
  const icon = variant === 'default' ? LE_ICON : GOOGLE_ICON
  return <Container data-testid={`${_MetaSearchTilePricing.name}-${variant}`}>
    {!hideLogoAndTitle && <BodyTextBlock startIcon={icon} variant="small" weight="bold" colour="neutral-one">
      {variant === 'default' && <FormattedMessage
        id="Sz1m+4ZhiC"
        defaultMessage="Luxury Escapes Price"
        description="Label for price comparison showing the Luxury Escapes price"
      />}
      {variant !== 'default' && <FormattedMessage
        id="YniYIjMTpK"
        defaultMessage="Price on Google"
        description="Label for price comparison showing the Google price"
      />}
    </BodyTextBlock>}
    <Group direction="vertical" gap={8}>
      <Details>{children}</Details>
      {!!action && <Action>{action}</Action>}
    </Group>
  </Container>
}

export default _MetaSearchTilePricing
